import { createContext, useContext, useState, PropsWithChildren } from "react";

interface GlobalFilterContextType {
  dateRange: string;
  fromDate: string;
  toDate: string;
  setDateRange: (v: string) => void;
  setFromDate: (v: string) => void;
  setToDate: (v: string) => void;
}

export const GlobalFilterContext = createContext<GlobalFilterContextType>({
  dateRange: "30d",
  fromDate: "",
  toDate: "",
  setDateRange: () => {},
  setFromDate: () => {},
  setToDate: () => {},
});

export function GlobalFilterProvider({ children }: PropsWithChildren<{}>) {
  const [dateRange, setDateRange] = useState("30d");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  return (
    <GlobalFilterContext.Provider value={{ dateRange, fromDate, toDate, setDateRange, setFromDate, setToDate }}>
      {children}
    </GlobalFilterContext.Provider>
  );
}

export function useGlobalFilter() {
  return useContext(GlobalFilterContext);
}
